export enum INDEXES {
  STUDY = 'study',
  PARTICIPANT = 'participant',
  FILE = 'file',
  BIOSPECIMEN = 'biospecimen',
  SETS = 'sets',
  VARIANTS = 'variants',
  GENES = 'genes',
}

export enum ES_INDEXES {
  VARIANT = 'variant',
}
